import {UserStorage} from "./UserStorage";
import {TokenStorage} from "./TokenStorage";

export class LocalStorage {
  static clear()
  {
    TokenStorage.clear();
    UserStorage.clear();
  }
}
